module.exports = __webpack_public_path__ + "static/media/photo_contact.d43a3d83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SideImage/photo_contact.jpg
// module id = 393
// module chunks = 0